export const strict = false

import { createStore } from "vuex"

// Modules
import auth from "./modules/auth"
import createPersistedState from "vuex-persistedstate"
import config from "@/config/app"
import errors from "./modules/errors"
import help from "./modules/help"
import cases from "./modules/cases"
import orders from "./modules/orders"
import resultFiles from "./modules/resultFiles"
import hospitals from "./modules/hospitals"
import sendOuts from "./modules/sendOuts"
import QCChartResultFiles from "./modules/QCChartResultFiles"
import physicians from "./modules/physicians"
import icd10Codes from "./modules/icd10Codes"
import userAccounts from "./modules/userAccounts"
import logs from "./modules/logs"
import updatePassword from "./modules/updatePassword"
import viewProgress from "./modules/viewProgress"
import profile from "./modules/profile"
import labs from "./modules/labs"
import labTests from "./modules/labTests"
import branches from "./modules/branches"
import payors from "./modules/payors"
import networkPayors from "./modules/networkPayors"
import reportFiles from "./modules/reportFiles"
import respiratoryFileUpload from "./modules/respiratoryFileUpload"
import patients from "./modules/patients"
import qcCharts from "./modules/qcCharts"
import emailLogs from "./modules/emailLogs"
import pendingCases from "./modules/pendingCases"
import tsiReports from "./modules/tsiReports"
import labDocuments from "./modules/labDocuments"
import session from "./modules/session"
import testpanel from "./modules/testpanel"
import bloodConfig from "./modules/bloodConfig"
import bloodQcLevels from "./modules/bloodQcLevels"
import bloodResults from "./modules/bloodResults"
import bloodTestLevels from "./modules/bloodTestLevels"
import patientPortal from "./modules/patientPortal"
import logistics from "./modules/logistics"
import patientReport from "./modules/patientReport"
import bloodOtherTests from "./modules/bloodOtherTests"
import insurances from "./modules/insurances"
import labsquireTestTubesInfo from "./modules/labsquireTestTubesInfo"
import testTubesImageGeneration from "./modules/testTubesImageGeneration"
import labSquireOrderTestTubes from "./modules/labSquireOrderTestTubes"
import rejectTestInfo from "./modules/rejectTestInfo"
import rulebook from "./modules/rulebook"
import swapInsurance from "./modules/swapInsurance"
import exceptionReport from "./modules/exceptionReport"
import emrOrders from "./modules/emrOrders"
import emrInsurances from "./modules/emrInsurances"
import systemLogs from "./modules/systemLogs"
import vendors from "./modules/vendors"
import instrumentQueue from "./modules/instrumentQueue"
const moduleNames = [
  "auth",
  "errors",
  "profile",
  "session",
  "qcCharts",
  "orders",
  "patientPortal",
  "bloodTestLevels",
  "bloodResults",
  "bloodQcLevels",
  "bloodConfig",
  "help",
  "cases",
  "resultFiles",
  "hospitals",
  "sendOuts",
  "QCChartResultFiles",
  "physicians",
  "icd10Codes",
  "userAccounts",
  "logs",
  "labs",
  "updatePassword",
  "viewProgress",
  "labTests",
  "branches",
  "payors",
  "networkPayors",
  "reportFiles",
  "respiratoryFileUpload",
  "patients",
  "pendingCases",
  "emailLogs",
  "tsiReports",
  "labDocuments",
  "testpanel",
  "logistics",
  "patientReport",
  "bloodOtherTests",
  "insurances",
  "rejectTestInfo",
  "rulebook",
  "emrOrders",
  "emrInsurances",
  "systemLogs",
  "vendors",
  "instrumentQueue",
]

// Exclude very large modules from persistence to avoid localStorage quota issues
const persistedModuleNames = [
  "auth",
  "profile.profileData",
  "profile.profileUpdateStatus",
  "profile.profilePicUrlForHeader",
  "profile.profileUserNameForHeader",
  "profile.profileDesignationForHeader",
  "profile.statesData",
  "session",
];

const store = new createStore({
  modules: {
    auth,
    patientPortal,
    bloodTestLevels,
    bloodResults,
    bloodQcLevels,
    bloodConfig,
    profile,
    qcCharts,
    errors,
    help,
    cases,
    orders,
    resultFiles,
    hospitals,
    sendOuts,
    QCChartResultFiles,
    physicians,
    icd10Codes,
    userAccounts,
    logs,
    labs,
    updatePassword,
    viewProgress,
    labTests,
    branches,
    payors,
    networkPayors,
    reportFiles,
    respiratoryFileUpload,
    patients,
    pendingCases,
    emailLogs,
    session,
    tsiReports,
    labDocuments,
    testpanel,
    logistics,
    patientReport,
    bloodOtherTests,
    insurances,
    labsquireTestTubesInfo,
    labSquireOrderTestTubes,
    testTubesImageGeneration,
    rejectTestInfo,
    rulebook,
    swapInsurance,
    exceptionReport,
    emrOrders,
    emrInsurances,
    systemLogs,
    vendors,
    instrumentQueue,
  },
  strict: false,
  plugins: [
    createPersistedState({
      key: config.APP_NAME + "_" + config.APP_VERSION,
      paths: persistedModuleNames,
    }),
  ],
  actions: {
    roleSwitchReset({ commit }) {
      moduleNames
        .filter((module) => module !== "auth")
        .forEach((module) => {
          commit(`${module}/reset`)
        })
      localStorage.removeItem("componentShown")
      localStorage.removeItem("versionHandled")
      localStorage.removeItem("allCases_search_string")
    },
    globalReset({ commit }) {
      moduleNames.forEach((module) => {
        commit(`${module}/reset`)
      })
      localStorage.removeItem("componentShown")
      localStorage.removeItem("versionHandled")
      // clear persisted UI search for AllCases to avoid retaining previous session input
      localStorage.removeItem("allCases_search_string")
      // also clear persisted Vuex state if needed
      try {
        localStorage.removeItem(config.APP_NAME + "_" + config.APP_VERSION)
      } catch (e) {
        console.log("Error clearing persisted state:", e)
      }
    },
  },
})

export default store
